import React from "react";
import { Col, Row } from "react-bootstrap";
import * as s from "./index.module.scss";
import { PrismicRichText } from "@prismicio/react";
import secondaryFont from "@/utils/secondaryFont";

const SingleBlog = ({
  image,
  title,
  categoryTitle,
  date,
  text,
  textRich,
  // buttonLink,
}) => {
  return (
    <Row className={s.single_blog}>
      <Col xs={12} md={6} lg={5} className="mb-4 mb-md-0">
        <img loading="lazy" src={image} alt="image" height="100%" />
      </Col>
      <Col xs={12} md={6} lg={7}>
        <h4 className="bold fw-bold heading">{title}</h4>
        <div className={s.filters}>
          <div className={`${secondaryFont} ${s.category} Paragraph`}>
            <p>{categoryTitle}</p>
          </div>
          <div className={`${secondaryFont} paragraph`}>
            <p>{date}</p>
          </div>
        </div>
        <div className={`${s.expertText}`}>
          {textRich ? (
            <div className={`${secondaryFont} paragraph`}>
              <PrismicRichText field={text || []} />
            </div>
          ) : (
            <p>{text || ""}</p>
          )}
        </div>
        {/* <div className="mt-3">
          <Link href={`/blogs/${buttonLink}`} className="btn btn-outline-dark">
            View More
          </Link>
        </div> */}
      </Col>
    </Row>
  );
};

export default SingleBlog;
